import {clsx} from 'clsx'
import type {ReactElement, Ref} from 'react'

import {ActionBarPanel} from './ActionBarPanel'
import styles from './AhpTaskChatInputActionBar.module.css'

export interface ItemsPanelProps {
  title: string
  items: readonly ReactElement[]
  onClose: () => void
  closeButtonRef?: Ref<HTMLButtonElement>
  nonInteractive?: boolean
}

export function ItemsPanel({title, items, onClose, closeButtonRef, nonInteractive}: ItemsPanelProps) {
  return (
    <ActionBarPanel
      className={clsx(styles.ItemsPanel, items.length > 5 && styles.ItemsPanelOverflowing)}
      title={title}
      listTabIndex={items.length > 5 ? 0 : undefined}
      onClose={onClose}
      closeButtonRef={closeButtonRef}
      nonInteractive={nonInteractive}
    >
      {items}
    </ActionBarPanel>
  )
}

ItemsPanel.displayName = 'ItemsPanel'
